<template>
  <div class="pagination-info">
    <span class="pagination-info__pages-info">
      {{ _getTr("show_x_to_y_of_z").format(firstElNumber, lastElNumber, total) }}
    </span>
    <span
      v-if="tableHintText"
      class="pagination-info__table-info"
    >
      {{ tableHintText }}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'PaginationInfo',
    props: {
      total: {
        type: Number,
        default: 0
      },
      currentPage: {
        type: Number,
        default: 0
      },
      perPage: {
        type: Number,
        default: 0
      },
      tableHintText: {
        type: String,
        default: ''
      }
    },
    computed: {
      firstElNumber () {
        return (this.currentPage - 1) * this.perPage + 1;
      },
      lastElNumber () {
        return Math.min(this.currentPage * this.perPage, this.total);
      }
    }
  };
</script>

<style>
  @media (--extra-small) {
    .pagination-info {
      margin-top: 10px;
    }
  }

  .pagination-info__table-info {
    margin-left: 16px;
  }
</style>
